/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { focusable } from './focus.js';
export function getFlattenedFocusableItems(element, depth = 10) {
    return getFlattenedDOMTree(element, depth).filter((e) => focusable(e));
}
export function getFlattenedDOMTree(node, depth = 10) {
    return Array.from(getChildren(node))
        .reduce((prev, next) => {
        return [...prev, [next, [...Array.from(getChildren(next)).map((i) => [i, getFlattenedDOMTree(i, depth)])]]];
    }, [])
        .flat(depth);
}
export function getChildren(node) {
    if (node.documentElement) {
        return node.documentElement.children;
    }
    else if (node.shadowRoot) {
        return node.shadowRoot.children;
    }
    else if (node.assignedElements) {
        const slotted = node.assignedElements(); // slotted elements
        return slotted.length ? slotted : node.children; // else slot fallback
    }
    else {
        return node.children;
    }
}
